import React, { FC, useEffect, useState } from 'react'
import _ from 'lodash'
import { RouteComponentProps } from "@reach/router"

import { field_attrs } from "components/table/lib/column-field"
import { Defaults_s } from "components/property/defaults/defaults-styles"
import DropdownInput from "components/inputs/dropdown"
import NumberInput from "components/inputs/number"
import { updateValidation } from "components/table/table-automation"

import api_match from "data/interface/api"
import inflationService from "data/inflation"
import propertyService from "data/property"
import validationService from "data/validate"

import { H4, Label_s } from "styles/app-styles"

const PropertyDefaultsMultifamily: FC<RouteComponentProps> = (props) => {
  const [property, setProperty] = useState<object>({})
  const [inflation, setInflation] = useState<object[]>([])

  useEffect(() => {
    const propertySubscription = propertyService.stream().subscribe(data => {
      if (data.value.length > 0){
        let current = propertyService.get();
        setProperty(current);
      }
    })
    const inflationSubscription = inflationService.stream().subscribe(data => {
      api_match(
        data,
        init  => setInflation(init.value),
        ok    => {
          setInflation(ok.value)
        },
        err   => {
          setInflation(err.value) // backout any optimistic updates
        },
        fetch => {}
      )
    })

    if (localStorage.getItem('property')){
      inflationService.fetchInflation(parseInt(localStorage.getItem('property')!))
    }

    return function cleanup() {
      inflationSubscription.unsubscribe();
      propertySubscription.unsubscribe();
    }

  }, [])

  useEffect(() => {
    updateValidation()
  },[property, inflation])

  const persist = (field, val) => {
    const nextProperty = _.cloneDeep(property);
    let data = nextProperty['defaultsmultifamily'];
    data[field] = val;
    if ((field === 'makeReadyAmtType' || field === 'commissionAmtType') && (val === '% of Rent Paid' || val === '# of Mos Rent')){
      if (field === 'makeReadyAmtType') data['makeReadyInflation'] = null
      if (field === 'commissionAmtType') data['commissionInflation'] = null
    }
    propertyService.patch(nextProperty)
      .then(() => validationService.validateAfterChange(property, nextProperty, propertyService.value()))
  }

  const namedItemPersist = (field, val) => {
    const nextProperty = _.cloneDeep(property);
    let data = nextProperty['defaultsmultifamily'];
    if (data[field]){
      data[field]['inflationNamedItemId'] = Number(val);
    } else {
      data[field] = {inflationMode: "namedItem", inflationNamedItemId: Number(val)}
    }
    propertyService.patch(nextProperty)
    .then(() => validationService.validateAfterChange(property, nextProperty, propertyService.value()))
  }

  const data = property['defaultsmultifamily'] || {};
  const commissionAmtTypes = ['% of Rent Paid', 'Amt/Area', 'Amt/Unit', '# of Mos Rent'];
  const rentAmtTypes = ['/Area/Mo', '/Area/Yr', '/Unit/Mo', '/Unit/Yr'];
  const freeRentTimingOptions = ['Lease Begin', 'Spread Evenly', 'Lease End'];
  const makeReadyAmtTypes = ['% of Rent Paid', 'Amt/Area', 'Amt/Unit', '# of Mos Rent'];

  const attrs = (field) => field_attrs('property', 'defaultsmultifamily')(field)(property, props)

  return (
    <Defaults_s>
      <div>
        <H4>Revenue</H4>
        <hr />
        <div>
          <div>
            <Label_s>Rent: Amt Type</Label_s>
            <DropdownInput
              field="rentAmtType"
              options={rentAmtTypes.map(opt => { return {'label': opt, 'value': opt}})}
              value={data['rentAmtType']}
              persist={persist}
              attrs={attrs}
            />
          </div>
          <div>
            <Label_s>Rent: Inflation</Label_s>
            <DropdownInput
              field="rentInflation"
              options={inflation.map(option => { return { label: option['code'], value: option['inflationid'] }})}
              value={data['rentInflation'] && data['rentInflation'].inflationNamedItemId}
              persist={namedItemPersist}
              attrs={attrs}
          />
          </div>
          <div>
            <Label_s>Free Rent: Timing</Label_s>
            <DropdownInput
              field="freeRentTiming"
              options={freeRentTimingOptions.map(opt => { return {'label': opt, 'value': opt}})}
              value={data['freeRentTiming']}
              persist={persist}
              attrs={attrs}
            />
          </div>
          <div>
            <Label_s>Market Term</Label_s>
            <NumberInput
              field="marketTerm"
              value={data['marketTerm']}
              persist={persist}
              readPrecision={0}
              writePrecision={0}
              attrs={attrs}
            />
          </div>
        </div>
      </div>
      <div>
        <div>
          <div>
            <Label_s>Make Ready: Amt Type</Label_s>
            <DropdownInput
              field="makeReadyAmtType"
              options={makeReadyAmtTypes.map(opt => { return {'label': opt, 'value': opt}})}
              value={data['makeReadyAmtType']}
              persist={persist}
              attrs={attrs}
              />
          </div>
          <div>
            <Label_s>Make Ready: Inflation</Label_s>
            <DropdownInput
              disabled={data['makeReadyAmtType'] && !data['makeReadyAmtType'].startsWith('Amt')}
              field="makeReadyInflation"
              options={inflation.map(option => { return { label: option['code'], value: option['inflationid'] }})}
              value={data['makeReadyInflation'] && data['makeReadyInflation'].inflationNamedItemId}
              persist={namedItemPersist}
              attrs={attrs}
              />
          </div>
          <div>
            <Label_s>Commission: Amt Type</Label_s>
            <DropdownInput
              field="commissionAmtType"
              options={commissionAmtTypes.map(opt => { return {'label': opt, 'value': opt}})}
              value={data['commissionAmtType']}
              persist={persist}
              attrs={attrs}
              />
          </div>
          <div>
            <Label_s>Commission: Inflation</Label_s>
            <DropdownInput
              field="commissionInflation"
              disabled={data['commissionAmtType'] && !data['commissionAmtType'].startsWith('Amt')}
              options={inflation.map(option => { return { label: option['code'], value: option['inflationid'] }})}
              value={data['commissionInflation'] && data['commissionInflation'].inflationNamedItemId}
              persist={namedItemPersist}
              attrs={attrs}
              />
          </div>
        </div>
      </div>
    </Defaults_s>
  )
}

export default PropertyDefaultsMultifamily

